/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { apiCommonResponse } from 'src/app/models/apiCommonResponse';
import { DropDown } from 'src/app/models/dropDown';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { Product, ProductListResponse } from 'src/app/models/products';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private apiUrl = `${environment.base_url}/products`;

  constructor(private http: HttpClient) {}

  addProduct(data: Product, vendorId: string): Observable<Product> {
    return this.http.post<Product>(
      `${environment.base_url}product?vendorId:${vendorId}`,
      data
    );
  }

  getLabel(): Observable<Array<DropDown>> {
    return this.http
      .get<{ data: Array<DropDown> }>(`${environment.base_url}labelDropdown`)
      .pipe(map(res => res.data));
  }

  editProduct(
    data: Product | { isBlocked: boolean },
    id: string
  ): Observable<Product> {
    return this.http.put<Product>(`${environment.base_url}product/${id}`, data);
  }

  getProductList(query: string): Observable<ProductListResponse> {
    return this.http
      .get<{
        data: ProductListResponse;
      }>(`${environment.base_url}product?${query}`)
      .pipe(map(res => res.data));
  }

  getAllProductList(query: string, body: any): Observable<ProductListResponse> {
    return this.http
      .post<{
        data: ProductListResponse;
      }>(`${environment.base_url}allProducts?${query}`,body)
      .pipe(map(res => res.data));
  }

  getProductListToReq(query: string): Observable<ProductListResponse> {
    return this.http
      .get<{
        data: ProductListResponse;
      }>(`${environment.base_url}product/requests?${query}`)
      .pipe(map(res => res.data));
  }

  getFactoryInventory(factoryId: string): Observable<ProductListResponse> {
    return this.http
      .get<{
        data: ProductListResponse;
      }>(`${environment.base_url}getFactoryInventory/${factoryId}`)
      .pipe(map(res => res.data));
  }

  getProductListByFactory(factoryId: string,query: string): Observable<ProductListResponse> {
    return this.http
      .get<{
        data: ProductListResponse;
      }>(`${environment.base_url}product/factory/${factoryId}?${query}`)
      .pipe(map(res => res.data));
  }

  deleteProduct(id: string): Observable<apiCommonResponse> {
    return this.http.delete<apiCommonResponse>(
      `${environment.base_url}product/${id}`
    );
  }

  getProductData(id: string): Observable<Product> {
    return this.http
      .get<{ data: Product }>(`${environment.base_url}product/${id}`)
      .pipe(map(res => res.data));
  }

  getWarehouseList(variantId: string, query: string): Observable<any> {
    return this.http
      .get<any>(`${environment.base_url}getInventory/${variantId}?${query}`)
      .pipe(map(res => res.data));
  }

  updateWarehouse(data: any): Observable<any> {
    return this.http.post<any>(`${environment.operational_url}addInventory`, data);
  }

  updateisBlocked(data: any): Observable<any> {
    return this.http.put<any>(
      `${environment.base_url}statusChangeInventory`,
      data
    );
  }
  exportCsv(): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}productExport`
    );
  }

  getProductById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  printShelfBarcode(data: any): Observable<any> {
    return this.http.post(`${environment.operational_url}print-labels`, data);
  }
}
